module.exports = __webpack_public_path__ + "img/kfnImg.dc5370af.png";